module.exports = __webpack_public_path__ + "img/elasticsearch.227ae22b.svg";